<template>
  <div class="menucontrol-scroll fixed-top">
    <Banner />
    <Report />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import Report from "./components/Report.vue";
export default {
  components: {
    Banner,
    Report,
  },
};
</script>
